export default __webpack_public_path__ + "static/media/consent-2020.6feea974.jpg";